<template>
  <div class="w-100" :class="{'hasErr': validation}">
    <label> <span class="text-danger">*</span> Bài học</label>
    <vSelect
        v-model="examId"
        placeholder="Lựa chọn bài thi"
        :disabled="disableSelect"
        :options="examList"
        label="title"
        :class="{'is-invalid': validation}"
        :reduce="(exam) => exam.id"
        class="w-100"
        :multiple="isMultiple"
        @search="(query)=> queryKeyword(query)"
        @close="$emit('onClose')"
    >
      <template #list-footer>
        <li v-show="hasNextPage" ref="load" class="loader text-center">
          loading...
        </li>
      </template>
    </vSelect>
    <span class="invalid-feedback">{{ messageErr }}</span>
  </div>
</template>
<script>
import vSelect from 'vue-select';
import {GetExams} from "@/services/exam";
import CONFIG_APP from "@/configs";

export default {
  expose: ['resetData'],
  name: "select-select",
  components: {vSelect},
  props: {
    messageErr: {type: String, default: 'Vui lòng chọn bài thi.'},
    validation: Boolean,
    modelValue: String || Number,
    idOld: {type: Array, default: null},
    isMultiple: {type: Boolean, default: false}
  },
  data() {
    return {
      examId: null,
      hasNextPage: false,
      disableSelect: false,
      examList: [],
      page: 1
    }
  },
  computed: {
    per_page: () => {
      return CONFIG_APP.itemOnPage
    }
  },
  watch: {
    examId() {
      this.$emit('selected', this.examId)
      this.$emit('update:modelValue', this.examId)
    },
    examList() {
      this.examId = this.modelValue
    }
  },
  created() {
    this.getExam()
  },

  methods: {
    getExam(params) {
      this.hasNextPage = true
      if (!params) {
        params = {per_page: this.per_page, page: this.page}
      }
      GetExams(params).then(e => {
        if (e.data.status === 'success') {
          let data = e.data.data.exams.data
          if (this.idOld) {
            this.idOld.map(item => {
              let index = data.findIndex(el => el.id === item.id)
              if (index > -1) {
                data.splice(index, 1)
              }
            })
          }
          this.examId = this.modelValue
          this.examList = data
          this.disableSelect = false
          this.hasNextPage = false
        }
      }).catch(err => {
        if (err.response.data == 'failed') {
          location.reload();
        }
      })
    },
    queryKeyword(query) {
      this.subjects = []
      this.hasNextPage = true
      let params = {per_page: this.per_page, page: 1, keyword: query}
      this.getExam(params)
    },
    resetData() {
      this.examId = null
    }
  },

}
</script>
<style scoped lang="scss">
.hasErr {
  .is-invalid {
    ::v-deep .vs__dropdown-toggle {
      border-color: red;
    }
  }
}
</style>
